import React from 'react';
import { UserProfile, BallProfile } from '../../../utils/interfaces';

interface BallSectionProps {
  editableProfile: UserProfile;
  handleProfileChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const BallSection: React.FC<BallSectionProps> = ({ editableProfile, handleProfileChange }) => {
  return (
    <div className="profile-form-grid ball-section">
      <div className="club-card">
        <div className="form-field">
          <label htmlFor="ball.model">Model</label>
          <input
            type="text"
            id="ball.model"
            name="Ball.model"
            value={(editableProfile['Ball' as keyof UserProfile] as BallProfile)?.model || ''}
            onChange={handleProfileChange}
            placeholder="e.g., Pro V1"
            maxLength={40}
          />
        </div>
        <div className="form-field">
          <label htmlFor="ball.feel_preference">Feel <br />Preference</label>
          <select id="ball.feel_preference" name="Ball.feel_preference" value={(editableProfile['Ball' as keyof UserProfile] as any)?.feel_preference || ''} onChange={handleProfileChange}>
            <option value="" disabled>Select...</option>
            <option value="soft">Soft</option>
            <option value="firm">Firm</option>
            <option value="neutral">Neutral</option>
          </select>
        </div>
        <div className="form-field">
          <label htmlFor="ball.compression_rating">Compression <br />Rating</label>
          <input type="number" id="ball.compression_rating" name="Ball.compression_rating" value={(editableProfile['Ball' as keyof UserProfile] as any)?.compression_rating || ''} onChange={handleProfileChange} placeholder="e.g., 90" />
        </div>
        <div className="form-field">
          <label htmlFor="ball.spin_preference">Spin <br />Preference</label>
          <select id="ball.spin_preference" name="Ball.spin_preference" value={(editableProfile['Ball' as keyof UserProfile] as any)?.spin_preference || ''} onChange={handleProfileChange}>
            <option value="" disabled>Select...</option>
            <option value="high">High Spin</option>
            <option value="mid">Mid Spin</option>
            <option value="low">Low Spin</option>
          </select>
        </div>
        <div className="form-field">
          <label htmlFor="ball.short_game_priority">Short Game <br />Priority</label>
          <select id="ball.short_game_priority" name="Ball.short_game_priority" value={(editableProfile['Ball' as keyof UserProfile] as any)?.short_game_priority || ''} onChange={handleProfileChange}>
            <option value="" disabled>Select...</option>
            <option value="control">Spin/Control</option>
            <option value="distance">Distance</option>
            <option value="durability">Durability</option>
          </select>
        </div>
        <div className="form-field">
          <label htmlFor="ball.notes">Notes</label>
          <input type="text" id="ball.notes" name="Ball.notes" value={(editableProfile['Ball' as keyof UserProfile] as BallProfile)?.notes || ''} onChange={handleProfileChange} placeholder="Optional notes" maxLength={100} />
        </div>
      </div>
    </div>
  );
};

export default BallSection;
